// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.widget-table-options {
  display: flex;
  justify-content: flex-end;
}

.widget-modal-table {
  margin-bottom: 1rem;
}
.widget-modal-table:empty {
  margin-bottom: 0;
}
.widget-modal-table .paylixecommerce-table {
  border: 1px solid var(--black1);
  box-shadow: 0 1px 2px rgba(16, 24, 40, 0.05);
}
.widget-modal-table .paylixecommerce-table table tbody tr:hover {
  background: none;
}
.widget-modal-table .paylixecommerce-table table tbody tr td {
  border-top: 1px solid var(--black1) !important;
}

.price-modal-wrapper {
  display: flex;
  justify-content: space-between;
}
@media (max-width: 768px) {
  .price-modal-wrapper {
    width: 100%;
    flex-direction: column;
  }
}
.price-modal-wrapper .paylixecommerce-card-price {
  color: var(--black9);
}
.price-modal-wrapper .paylixecommerce-card-image {
  border-bottom-color: var(--black1);
}
.price-modal-wrapper .paylixecommerce-card-image.placeholder {
  background: var(--white);
}
.price-modal-wrapper .paylixecommerce-card-image.placeholder i {
  color: var(--black9);
}
.price-modal-wrapper .paylixecommerce-card-container {
  background: var(--white);
}
.price-modal-wrapper .paylixecommerce-card-info {
  background: var(--white);
}
.price-modal-wrapper > div:first-child {
  position: relative;
  width: calc(100% - 240px - 2rem);
}
@media (max-width: 768px) {
  .price-modal-wrapper > div:first-child {
    width: 100%;
  }
}
.price-modal-wrapper > div:last-child {
  position: relative;
  width: 240px;
  height: 280px;
}
@media (max-width: 768px) {
  .price-modal-wrapper > div:last-child {
    width: 100%;
  }
}

.paylixecommerce-cart-icon {
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
  pointer-events: visible;
  z-index: 1;
  display: flex;
}
.paylixecommerce-cart-icon.static {
  position: static;
}
.paylixecommerce-cart-icon.empty {
  justify-content: flex-end;
}
@media (max-width: 768px) {
  .paylixecommerce-cart-icon.empty.static a:nth-child(1) {
    opacity: 0;
    transform: translateX(0);
  }
  .paylixecommerce-cart-icon.empty.static a:nth-child(2) {
    transform: translateX(-3.25rem);
  }
  .paylixecommerce-cart-icon.empty.static a:nth-child(3) {
    transform: translateX(-5.5rem);
    opacity: 0;
  }
}
.paylixecommerce-cart-icon.empty a:nth-child(1) {
  opacity: 0;
  transform: translateX(4.5rem);
}
.paylixecommerce-cart-icon.empty a:nth-child(2) {
  transform: translateX(2.25rem);
}
.paylixecommerce-cart-icon.empty a:nth-child(3) {
  opacity: 0;
}
.paylixecommerce-cart-icon a {
  cursor: pointer;
  border-radius: 0.25rem;
  border: 1px solid var(--black1);
  background: var(--white);
  color: var(--black9) !important;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 2rem;
  height: 2rem;
  opacity: 1;
  transition: all 0.3s ease;
}
.paylixecommerce-cart-icon a:nth-child(1) {
  transform: translateX(0);
}
.paylixecommerce-cart-icon a:nth-child(2) {
  margin: 0 0.25rem;
  transform: translateX(0);
  z-index: 2;
}
.paylixecommerce-cart-icon a:hover {
  color: var(--black9) !important;
}
.paylixecommerce-cart-icon a svg {
  fill: var(--black5) !important;
  pointer-events: none;
  width: 1rem;
  height: 1rem;
}

.paylixecommerce-discount-icon {
  position: absolute;
  top: 0.5rem;
  left: 0.5rem;
  pointer-events: visible;
  z-index: 1;
  display: flex;
  border-radius: 0.25rem;
  border: 1px solid var(--black1);
  background: var(--purple6);
  color: white !important;
  justify-content: center;
  align-items: center;
  width: 2rem;
  height: 2rem;
  opacity: 1;
  transition: all 0.3s ease;
}
.paylixecommerce-discount-icon.group {
  position: static;
  margin-right: 0.5rem;
}

.paylixecommerce-card {
  display: flex;
  align-items: stretch;
  flex-direction: column;
  flex-grow: 1;
  background: var(--white);
}
.paylixecommerce-card-container {
  display: flex;
  align-items: stretch;
  flex-direction: column;
  flex-grow: 1;
  border: 1px solid var(--black1);
  cursor: pointer;
  border-radius: 0.5rem;
  overflow: hidden;
  position: relative;
}
.paylixecommerce-card-info {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 1rem;
  flex: 1 1 auto;
}
.paylixecommerce-card-image {
  min-height: 180px;
  margin: 0 auto;
  width: 100%;
}
.paylixecommerce-card-image.placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--purple6);
}
.paylixecommerce-card-image.placeholder i {
  font-size: 3rem;
}
.paylixecommerce-card-image img {
  width: 100%;
  height: 180px;
  border-top-left-radius: 0.5rem;
  border-top-right-radius: 0.5rem;
  object-fit: cover;
}
.paylixecommerce-card-title {
  font-size: 1rem;
  display: flex;
  width: 100%;
  color: var(--black5);
  line-height: 1.5rem;
  align-items: center;
}
.paylixecommerce-card-description {
  display: flex;
  justify-content: center;
  line-height: 1.25rem;
  margin-top: 0.75rem;
  font-size: 14px;
  color: var(--black5);
  align-items: flex-end;
}
.paylixecommerce-card-price {
  font-size: 14px;
  color: var(--purple6);
  font-weight: 500;
}
.paylixecommerce-card-price.with-discount {
  font-weight: 500;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  font-size: 1rem;
  line-height: 1rem;
}
.paylixecommerce-card-price.with-discount i {
  font-weight: 300;
  font-style: normal;
  font-size: 0.75rem;
  margin-right: 0.25rem;
  text-decoration: line-through;
}
.paylixecommerce-card-stock {
  font-size: 14px;
  color: var(--black9);
  opacity: 0.7;
}
.paylixecommerce-card-stock svg {
  height: 0.75rem;
  left: 0.125rem;
  position: relative;
  top: 0.125rem;
  width: 0.75rem;
}

#price_discount {
  -moz-appearance: textfield;
}
#price_discount::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.widget-custom-modal {
  max-width: 800px;
}

.widget-modal {
  margin-bottom: 2rem;
}
.widget-modal .paylixecommerce-label {
  display: flex !important;
}
.widget-modal:last-child {
  margin-bottom: 0;
}

.widget-button {
  margin-right: 0;
  margin-bottom: 0.5rem;
  width: 100%;
  min-height: 2.25rem;
  height: 2.25rem;
  border: 1px solid var(--black2);
  box-shadow: 0 1px 2px rgba(18, 20, 23, 0.06);
  border-radius: 8px;
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 17px;
  text-align: center;
  color: var(--black5);
  background: var(--white);
}

.widget-footer {
  display: flex;
  justify-content: space-between;
  width: 100%;
}

.dark .custom-widget {
  background: var(--black1);
}
.dark .custom-widget textarea.paylixecommerce-input {
  background-color: var(--white);
}
.dark .custom-widget .paylixecommerce-input {
  background-color: var(--white);
}
.dark .custom-widget .paylixecommerce-select {
  background-color: var(--white);
}
.dark .custom-widget button.primary:disabled {
  border: 1px solid var(--black6);
}
.dark .widget-modal .paylixecommerce-table table tbody {
  background: var(--black0);
}
.dark .widget-modal .paylixecommerce-table table thead tr th {
  background: var(--black0);
}

.custom-widget {
  border: 1px solid var(--black2);
  margin-bottom: 1.5rem;
  background: transparent;
  padding: 1.25rem;
  border-radius: 0.5rem;
  box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.05);
}
@media (max-width: 768px) {
  .custom-widget {
    padding: 1rem;
  }
}
.custom-widget-body {
  display: flex;
  justify-content: space-between;
  margin-bottom: 1.25rem;
}
@media (max-width: 768px) {
  .custom-widget-body {
    flex-wrap: wrap;
  }
  .custom-widget-body > div {
    width: calc(50% - 0.5rem) !important;
  }
  .custom-widget-body > div.is-select {
    width: 100% !important;
  }
  .custom-widget-body > div:first-child {
    width: 100% !important;
    margin-bottom: 1rem;
  }
}
.custom-widget-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-weight: 500;
  color: var(--black9);
}
.custom-widget-footer {
  display: flex;
  justify-content: space-between;
  width: 100%;
}
.custom-widget-footer button {
  width: calc(50% - 0.5rem);
  min-height: 2.25rem;
  height: 2.25rem;
}
.custom-widget-footer button.button-ghost {
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 17px;
  text-align: center;
  color: var(--black5);
}
.custom-widget .discount-currency {
  position: absolute;
  height: 40px;
  bottom: 0;
  align-items: center;
  display: flex;
  justify-content: center;
  padding: 1rem;
  font-weight: 500;
  font-size: 0.9rem;
  color: var(--black9);
}
.custom-widget .discount-currency + div input {
  padding-left: 2.25rem;
}`, "",{"version":3,"sources":["webpack://./client/entrypoints/dashboard/screens/products/product/screens/components/modals.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,yBAAA;AACF;;AAEA;EACE,mBAAA;AACF;AACE;EACE,gBAAA;AACJ;AAEE;EACE,+BAAA;EACA,4CAAA;AAAJ;AAGO;EACE,gBAAA;AADT;AAGO;EACE,8CAAA;AADT;;AAOA;EACE,aAAA;EACA,8BAAA;AAJF;AAME;EAJF;IAKI,WAAA;IACA,sBAAA;EAHF;AACF;AAKE;EACE,oBAAA;AAHJ;AAKE;EACE,kCAAA;AAHJ;AAME;EACE,wBAAA;AAJJ;AAMI;EACE,oBAAA;AAJN;AAOE;EACE,wBAAA;AALJ;AAOE;EACE,wBAAA;AALJ;AAUI;EACE,kBAAA;EACA,gCAAA;AARN;AAUM;EAJF;IAKI,WAAA;EAPN;AACF;AASI;EAKE,kBAAA;EACA,YAAA;EACA,aAAA;AAXN;AAKM;EADF;IAEI,WAAA;EAFN;AACF;;AAWA;EACE,kBAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,UAAA;EACA,aAAA;AARF;AAUE;EACE,gBAAA;AARJ;AAWE;EACE,yBAAA;AATJ;AAYM;EAEI;IACE,UAAA;IACA,wBAAA;EAXV;EAaQ;IACE,+BAAA;EAXV;EAaQ;IACE,8BAAA;IACA,UAAA;EAXV;AACF;AAiBM;EACE,UAAA;EACA,6BAAA;AAfR;AAiBM;EACE,8BAAA;AAfR;AAiBM;EACE,UAAA;AAfR;AAqBE;EACE,eAAA;EACA,sBAAA;EACA,+BAAA;EACA,wBAAA;EACA,+BAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,yBAAA;AAnBJ;AAqBI;EACE,wBAAA;AAnBN;AAsBI;EACE,iBAAA;EACA,wBAAA;EACA,UAAA;AApBN;AA2BI;EACE,+BAAA;AAzBN;AA4BI;EACE,8BAAA;EACA,oBAAA;EACA,WAAA;EACA,YAAA;AA1BN;;AAgCA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,uBAAA;EACA,UAAA;EACA,aAAA;EAEA,sBAAA;EACA,+BAAA;EACA,0BAAA;EACA,uBAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,yBAAA;AA9BF;AAgCE;EACE,gBAAA;EACA,oBAAA;AA9BJ;;AAqCA;EACE,aAAA;EACA,oBAAA;EACA,sBAAA;EACA,YAAA;EACA,wBAAA;AAlCF;AAoCE;EACE,aAAA;EACA,oBAAA;EACA,sBAAA;EACA,YAAA;EACA,+BAAA;EACA,eAAA;EACA,qBAAA;EACA,gBAAA;EACA,kBAAA;AAlCJ;AAqCE;EACE,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,aAAA;EACA,cAAA;AAnCJ;AAsCE;EACE,iBAAA;EACA,cAAA;EACA,WAAA;AApCJ;AAsCI;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,qBAAA;AApCN;AAsCM;EACE,eAAA;AApCR;AAwCI;EACE,WAAA;EACA,aAAA;EACA,8BAAA;EACA,+BAAA;EACA,iBAAA;AAtCN;AA0CE;EACE,eAAA;EACA,aAAA;EACA,WAAA;EACA,oBAAA;EACA,mBAAA;EACA,mBAAA;AAxCJ;AA2CE;EACE,aAAA;EACA,uBAAA;EACA,oBAAA;EACA,mBAAA;EACA,eAAA;EACA,oBAAA;EACA,qBAAA;AAzCJ;AA4CE;EACE,eAAA;EACA,qBAAA;EACA,gBAAA;AA1CJ;AA4CI;EACE,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,2BAAA;EACA,eAAA;EACA,iBAAA;AA1CN;AA4CM;EACE,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,qBAAA;EACA,6BAAA;AA1CR;AA+CE;EACE,eAAA;EACA,oBAAA;EACA,YAAA;AA7CJ;AA+CI;EACE,eAAA;EACA,cAAA;EACA,kBAAA;EACA,aAAA;EACA,cAAA;AA7CN;;AAmDA;EACE,0BAAA;AAhDF;AAiDE;EACE,wBAAA;EACA,SAAA;AA/CJ;;AAmDA;EACE,gBAAA;AAhDF;;AAmDA;EACE,mBAAA;AAhDF;AAkDE;EACE,wBAAA;AAhDJ;AAmDE;EACE,gBAAA;AAjDJ;;AAqDA;EACE,eAAA;EACA,qBAAA;EACA,WAAA;EACA,mBAAA;EACA,eAAA;EACA,+BAAA;EACA,4CAAA;EACA,kBAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,oBAAA;EACA,wBAAA;AAlDF;;AAqDA;EACE,aAAA;EACA,8BAAA;EACA,WAAA;AAlDF;;AAsDE;EACE,yBAAA;AAnDJ;AAqDI;EACE,8BAAA;AAnDN;AAqDI;EACE,8BAAA;AAnDN;AAqDI;EACE,8BAAA;AAnDN;AAqDI;EACE,+BAAA;AAnDN;AAyDM;EACE,yBAAA;AAvDR;AAyDM;EACE,yBAAA;AAvDR;;AA6DA;EACE,+BAAA;EACA,qBAAA;EACA,uBAAA;EACA,gBAAA;EACA,qBAAA;EACA,8CAAA;AA1DF;AA4DE;EARF;IASI,aAAA;EAzDF;AACF;AA2DE;EACE,aAAA;EACA,8BAAA;EACA,sBAAA;AAzDJ;AA2DI;EALF;IAMI,eAAA;EAxDJ;EA0DI;IACE,oCAAA;EAxDN;EA0DM;IACE,sBAAA;EAxDR;EA2DM;IACE,sBAAA;IACA,mBAAA;EAzDR;AACF;AA+DE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,gBAAA;EACA,oBAAA;AA7DJ;AAgEE;EACE,aAAA;EACA,8BAAA;EACA,WAAA;AA9DJ;AAgEI;EACE,yBAAA;EACA,mBAAA;EACA,eAAA;AA9DN;AAgEM;EACE,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,oBAAA;AA9DR;AAmEE;EACE,kBAAA;EACA,YAAA;EACA,SAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,aAAA;EACA,gBAAA;EACA,iBAAA;EACA,oBAAA;AAjEJ;AAmEI;EACE,qBAAA;AAjEN","sourcesContent":[".widget-table-options {\n  display: flex;\n  justify-content: flex-end;\n}\n\n.widget-modal-table {\n  margin-bottom: 1rem;\n\n  &:empty {\n    margin-bottom: 0;\n  }\n\n  .paylixecommerce-table {\n    border: 1px solid var(--black1);\n    box-shadow: 0 1px 2px rgba(16, 24, 40, 0.05);\n\n     & table tbody tr {\n       &:hover {\n         background: none;\n       }\n       td {\n         border-top: 1px solid var(--black1) !important;\n       }\n     }\n  }\n}\n\n.price-modal-wrapper {\n  display: flex;\n  justify-content: space-between;\n\n  @media (max-width: 768px) {\n    width: 100%;\n    flex-direction: column;\n  }\n\n  .paylixecommerce-card-price {\n    color: var(--black9);\n  }\n  .paylixecommerce-card-image {\n    border-bottom-color: var(--black1);\n  }\n\n  .paylixecommerce-card-image.placeholder {\n    background: var(--white);\n\n    i {\n      color: var(--black9);\n    }\n  }\n  .paylixecommerce-card-container {\n    background: var(--white);\n  }\n  .paylixecommerce-card-info {\n    background: var(--white);\n  }\n\n\n  & > div {\n    &:first-child {\n      position: relative;\n      width: calc(100% - 240px - 2rem);\n\n      @media (max-width: 768px) {\n        width: 100%;\n      }\n    }\n    &:last-child {\n      @media (max-width: 768px) {\n        width: 100%;\n      }\n\n      position: relative;\n      width: 240px;\n      height: 280px;\n    }\n  }\n}\n\n.paylixecommerce-cart-icon {\n  position: absolute;\n  top: .5rem;\n  right: .5rem;\n  pointer-events: visible;\n  z-index: 1;\n  display: flex;\n\n  &.static {\n    position: static;\n  }\n\n  &.empty {\n    justify-content: flex-end;\n\n    &.static {\n      @media (max-width: 768px) {\n        a {\n          &:nth-child(1) {\n            opacity: 0;\n            transform: translateX(0);\n          }\n          &:nth-child(2) {\n            transform: translateX(-3.25rem);\n          }\n          &:nth-child(3) {\n            transform: translateX(-5.5rem);\n            opacity: 0;\n          }\n        }\n      }\n    }\n\n    a {\n      &:nth-child(1) {\n        opacity: 0;\n        transform: translateX(4.5rem)\n      }\n      &:nth-child(2) {\n        transform: translateX(2.25rem)\n      }\n      &:nth-child(3) {\n        opacity: 0;\n      }\n    }\n  }\n\n\n  a {\n    cursor: pointer;\n    border-radius: .25rem;\n    border: 1px solid var(--black1);\n    background: var(--white);\n    color: var(--black9) !important;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 2rem;\n    height: 2rem;\n    opacity: 1;\n    transition: all .3s ease;\n\n    &:nth-child(1) {\n      transform: translateX(0)\n    }\n\n    &:nth-child(2) {\n      margin: 0 .25rem;\n      transform: translateX(0);\n      z-index: 2;\n    }\n\n    &:nth-child(3) {\n\n    }\n\n    &:hover {\n      color: var(--black9) !important;\n    }\n\n    svg {\n      fill: var(--black5) !important;\n      pointer-events: none;\n      width: 1rem;\n      height: 1rem;\n    }\n  }\n\n}\n\n.paylixecommerce-discount-icon {\n  position: absolute;\n  top: .5rem;\n  left: .5rem;\n  pointer-events: visible;\n  z-index: 1;\n  display: flex;\n\n  border-radius: .25rem;\n  border: 1px solid var(--black1);\n  background: var(--purple6);\n  color: white !important;\n  justify-content: center;\n  align-items: center;\n  width: 2rem;\n  height: 2rem;\n  opacity: 1;\n  transition: all .3s ease;\n\n  &.group {\n    position: static;\n    margin-right: .5rem;\n  }\n\n}\n\n\n\n.paylixecommerce-card {\n  display: flex;\n  align-items: stretch;\n  flex-direction: column;\n  flex-grow : 1;\n  background: var(--white);\n\n  &-container {\n    display: flex;\n    align-items: stretch;\n    flex-direction: column;\n    flex-grow : 1;\n    border: 1px solid var(--black1);\n    cursor: pointer;\n    border-radius: .5rem;\n    overflow: hidden;\n    position: relative;\n  }\n\n  &-info {\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    padding: 1rem;\n    flex: 1 1 auto;\n  }\n\n  &-image {\n    min-height: 180px;\n    margin: 0 auto;\n    width: 100%;\n\n    &.placeholder {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      color: var(--purple6);\n\n      i {\n        font-size: 3rem;\n      }\n    }\n\n    img {\n      width: 100%;\n      height: 180px;\n      border-top-left-radius: .5rem;\n      border-top-right-radius: .5rem;\n      object-fit: cover;\n    }\n  }\n\n  &-title {\n    font-size: 1rem;\n    display: flex;\n    width: 100%;\n    color: var(--black5);\n    line-height: 1.5rem;\n    align-items: center;\n  }\n\n  &-description {\n    display: flex;\n    justify-content: center;\n    line-height: 1.25rem;\n    margin-top: .75rem;\n    font-size: 14px;\n    color: var(--black5);\n    align-items: flex-end;\n  }\n\n  &-price {\n    font-size: 14px;\n    color: var(--purple6);\n    font-weight: 500;\n\n    &.with-discount {\n      font-weight: 500;\n      display: flex;\n      flex-direction: column;\n      justify-content: flex-start;\n      font-size: 1rem;\n      line-height: 1rem;\n\n      i {\n        font-weight: 300;\n        font-style: normal;\n        font-size: .75rem;\n        margin-right: 0.25rem;\n        text-decoration: line-through;\n      }\n    }\n  }\n\n  &-stock {\n    font-size: 14px;\n    color: var(--black9);\n    opacity: .7;\n\n    svg {\n      height: .75rem;\n      left: .125rem;\n      position: relative;\n      top: .125rem;\n      width: .75rem;\n    }\n  }\n}\n\n\n#price_discount {\n  -moz-appearance: textfield;\n  &::-webkit-inner-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n  }\n}\n\n.widget-custom-modal {\n  max-width: 800px;\n}\n\n.widget-modal {\n  margin-bottom: 2rem;\n\n  .paylixecommerce-label {\n    display: flex !important;\n  }\n\n  &:last-child {\n    margin-bottom: 0;\n  }\n}\n\n.widget-button {\n  margin-right: 0;\n  margin-bottom: .5rem;\n  width: 100%;\n  min-height: 2.25rem;\n  height: 2.25rem;\n  border: 1px solid var(--black2);\n  box-shadow: 0 1px 2px rgba(18, 20, 23, 0.06);\n  border-radius: 8px;\n  font-family: 'Inter';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 17px;\n  text-align: center;\n  color: var(--black5);\n  background: var(--white);\n}\n\n.widget-footer {\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n}\n\n.dark {\n  .custom-widget {\n    background: var(--black1);\n\n    textarea.paylixecommerce-input {\n      background-color: var(--white);\n    }\n    .paylixecommerce-input {\n      background-color: var(--white);\n    }\n    .paylixecommerce-select {\n      background-color: var(--white);\n    }\n    button.primary:disabled {\n      border: 1px solid var(--black6);\n    }\n  }\n\n  .widget-modal {\n    .paylixecommerce-table table {\n      tbody {\n        background: var(--black0);\n      }\n      thead tr th {\n        background: var(--black0);\n      }\n    }\n  }\n}\n\n.custom-widget {\n  border: 1px solid var(--black2);\n  margin-bottom: 1.5rem;\n  background: transparent;\n  padding: 1.25rem;\n  border-radius: .5rem;\n  box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.05);\n\n  @media (max-width: 768px) {\n    padding: 1rem;\n  }\n\n  &-body {\n    display: flex;\n    justify-content: space-between;\n    margin-bottom: 1.25rem;\n\n    @media (max-width: 768px) {\n      flex-wrap: wrap;\n\n      & > div {\n        width: calc(50% - .5rem) !important;\n\n        &.is-select {\n          width: 100% !important;\n        }\n\n        &:first-child {\n          width: 100% !important;\n          margin-bottom: 1rem;\n        }\n      }\n\n    }\n  }\n\n  &-header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    font-weight: 500;\n    color: var(--black9);\n  }\n\n  &-footer {\n    display: flex;\n    justify-content: space-between;\n    width: 100%;\n\n    button {\n      width: calc(50% - .5rem);\n      min-height: 2.25rem;\n      height: 2.25rem;\n\n      &.button-ghost {\n        font-family: 'Inter';\n        font-style: normal;\n        font-weight: 500;\n        font-size: 14px;\n        line-height: 17px;\n        text-align: center;\n        color: var(--black5);\n      }\n    }\n  }\n\n  .discount-currency {\n    position: absolute;\n    height: 40px;\n    bottom: 0;\n    align-items: center;\n    display: flex;\n    justify-content: center;\n    padding: 1rem;\n    font-weight: 500;\n    font-size: .9rem;\n    color: var(--black9);\n\n    & + div input {\n      padding-left: 2.25rem;\n    }\n  }\n\n};\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
